export default [
    {
        path: '/abnormal/applyList',
        component: () => import('@/views/abnormal/ApplyList.vue'),
        meta: {
            title: '异常数据申请',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        path: '/abnormal/applyDetail',
        component: () => import('@/views/abnormal/ApplyDetail.vue'),
        meta: {
            title: '异常数据申请详情',
            isTabsPage: true,
            keepAlive: false
        }
    },
    {
        path: '/abnormal/applyShenpi',
        component: () => import('@/views/abnormal/ApplyShenpi.vue'),
        meta: {
            title: '异常数据申请审批',
            isTabsPage: true,
            keepAlive: false
        }
    }
]
